import { withPrefix } from 'gatsby';

export const APPSTORE_ICON = withPrefix('/icons/app-apple.svg');
export const PLAYSTORE_ICON = withPrefix('/icons/app-google.svg');

export const APP_DOWNLOAD_PLAYSTORE =
  'https://play.google.com/store/apps/details?id=de.adac.camping23';
export const APP_DOWNLOAD_APPSTORE =
  'https://apps.apple.com/de/app/adac-camping-stellplatz-2023/id6444773343';
